<template>
    <router-view />
</template>

<script>
import authService from "./auth/AuthorizeService";
import { initConfig } from "./appConfig";

export default {
  name: 'App',
  async beforeMount() {
    await authService.isAuthenticated();
    initConfig();
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 100%;
  height: 100%;

}
html{
    height: 100%;
    width: 100%;
}
body{
    height: 100%;
    width: 100%;
    margin: 0;
}

.navigator-bar {
    width: 75%;
    height: 2px;
    background-color: gray;
    margin: 50px 0 25px 0;
    margin-left: 12%;
    position: relative;
}

</style>
